import { LITTLE_GUY_WEBCOMPONENT_FEATURE } from '../constants';

// List of event keys that are used in the application.
const usedEventKeys = new Set([
    'fyd_ddp_visit',
    'global_pageview',
    'fyd_ddp_exit',
    'fyd_srl_visit',
    'fyd_srl_exit',
    'fyd_srl_listing_click',
]);

// List of feature flag keys that are used in the application.
const usedFeatureFlagKeys = new Set([
    'disable_personalization_engine',
    'disable_thirdparty',
    'col_enable_one_trust_footer',
    LITTLE_GUY_WEBCOMPONENT_FEATURE,
    'chat',
    'show_wallet_alert_notification',
    // required flag
    'email_cta_alternative_label',
    'auth_optimizely_demo',
    'optimizely_snippet',
    'google_analytics',
    'disable_spotlights',
    'psx_cta_webcomponents',
    'advanced_keyword_search',
    'exclude_tags_override',
    'mobile_app_interstitial_test',
]);

const filteredRollouts = (filteredFeatureFlags, rollouts) => {
    const rolloutIds = new Set(
        filteredFeatureFlags.map((f) => f.rolloutId).filter(Boolean),
    );
    return rollouts.filter((r) => rolloutIds.has(r.id));
};

export default function filterOptimizelyData(fullConfig) {
    if (!fullConfig || !fullConfig.dataFile) return null;

    const {
        accountId,
        projectId,
        revision,
        attributes,
        audiences = [],
        version,
        events = [],
        integrations = [],
        anonymizeIP,
        botFiltering,
        typedAudiences = [],
        variables = [],
        environmentKey,
        sdkKey,
        featureFlags = [],
        rollouts = [],
        experiments = [],
        groups = [],
    } = fullConfig.dataFile || {};

    const filteredFeatureFlags = featureFlags.filter((flag) => (flag.variables?.length > 0 || usedFeatureFlagKeys.has(flag.key)));

    const filteredEvents = events.filter((event) => usedEventKeys.has(event.key));

    const filteredRolloutsArr = filteredRollouts(
        filteredFeatureFlags,
        rollouts,
    );

    return {
        dataFile: {
            accountId,
            projectId,
            revision,
            attributes,
            audiences,
            version,
            integrations,
            anonymizeIP,
            botFiltering,
            typedAudiences,
            variables,
            environmentKey,
            sdkKey,
            experiments,
            groups,
            featureFlags: filteredFeatureFlags,
            events: filteredEvents,
            rollouts: filteredRolloutsArr,
        },
        user: fullConfig.user || {},
        forcedFeatures: fullConfig.forcedFeatures || {},
        forcedExperiments: fullConfig.forcedExperiments || [],
    };
}
